import React, {useContext} from 'react';

import Link from '~/src/components/link/Link';

import {getContentUrl} from '~/src/utilities/helpers/link';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {classNames, getFormatClassNames} from '~/src/utilities/helpers/css';
import {createTopItemTracker} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import PageContext from '~/src/components/context/PageContext';

import css from './TeaserTopPopular.module.scss';

interface TeaserTopPopularItem {
    title: string;
    url: string;
}

interface TeaserTopPopularProps {
    content: {
        title: string;
    };
    data?: TeaserTopPopularItem[];
    format?: {
        primaryGrid: string;
        secondaryGrid?: string;
        colorScheme?: string;
    };
}

const TeaserTopPopular = ({data, content, format}: TeaserTopPopularProps) => {
    const {siteArea} = useContext(SettingsContext);
    const {gtmPageType} = useContext(PageContext);

    const className = classNames(css, 'container', siteArea, getFormatClassNames(format));

    return (
        <div className={className}>
            <header className={css.header}>
                <h2 className={css.title}>{content.title}</h2>
            </header>
            <section className={css.items}>
                {data?.map((item, index) => {
                    return (
                        <Link
                            key={index}
                            className={css.item}
                            href={getContentUrl(item.url)}
                            onClick={createTopItemTracker(GtmEvents.WIDGET_MOST_POPULAR, gtmPageType, item.url?.substr(-12) || '', index, item.title)}
                        >
                            {item.title}
                        </Link>
                    );
                })}
            </section>
        </div>
    );
};

export default TeaserTopPopular;
